import { FieldType, Field, ComparisonOperator } from "../../vforms-model";
import { SingleSelectionListComponent } from "./single-selection-list.component";
import { SingleSelectionListEditorComponent } from "./single-selection-list-editor.component";
import { SelectionList } from "../selection-list";
import { ComparisonExpression } from "../../expression-settings/model";

export class SingleSelectionListType extends FieldType {
    static Id = "single-selection-list";

    constructor() {
        super();
        this.id = SingleSelectionListType.Id;
        this.icon = "mat_outline:radio_button_checked";
        this.previewComponent = SingleSelectionListComponent;
        this.editorComponent = SingleSelectionListEditorComponent;
    }

    createField(): Field {
        return new SelectionList(this);
    }

    supportedComparisonOperators(): ComparisonOperator[] {
        return [...super.supportedComparisonOperators(), ComparisonOperator.Equal, ComparisonOperator.NotEqual];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        switch (expression.operator) {
            case ComparisonOperator.Equal:
                return value === expression.value;
            case ComparisonOperator.NotEqual:
                return value !== expression.value;
        }
        return super.evaluate(expression, value);
    }
}
